import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_WeeklyTelephoneConsultation = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_WeeklyTelephoneConsultation' className='file-pdf-document'>
            <div className='file-template'>

                <h3>MST WEEKLY TELEPHONE CONSULTATION SIGN-IN
                </h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Consultant's Name:</span>
                            <input type="text" id="txtConsultantName" name="txtConsultantName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DATE:</span>
                            <input type="date" id="txtDate" name="txtDate" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>TIME:</span>
                            <input type="time" id="txtTime" name="txtTime" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>PURPOSE:</span>
                            <select id="ddlPurposeRecurrenceMeeting" name="ddlPurposeRecurrenceMeeting" className='add-only'>
                                <option value="Na"></option>
                                <option value="weekly">Weekly</option>
                                <option value="bimonthly">Bimonthly </option>
                                <option value="monthly">Monthly</option>
                            </select>                          
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>LOCATION:</span>
                            2706 Saint Jude Street, Greensboro, NC 27405
                        </td>                      
                    </tr>
                </table>
                <h4>SIGN-IN LOG
                </h4>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtSignIn1" name="txtSignIn1" placeholder="(MST-PSB Supervisor)" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtSignIn2" name="txtSignIn2" placeholder="(MST-PSB Supervisor)" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtSignIn3" name="txtSignIn3" placeholder="(MST-PSB Supervisor)" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtSignIn4" name="txtSignIn4" placeholder="(MST-PSB Supervisor)" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Items addressed during the Consultation session</span>
                    MST WEEKLIES ARE REVIEWED WITH CONSULTANT & STAFF VIA TELEPHONE, PLEASE SEE ATTACHMENTS.
                </p>



            </div>
        </form>

    )
}  
